























import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import { computed, defineComponent } from '@vue/composition-api';

export default defineComponent({
  components: {
    VueSlider,
  },
  props: {
    onPlaying: {
      type: Boolean,
      default: false,
    },
    currentTime: {
      type: String,
      default: '',
    },
    allTime: {
      type: String,
      default: '',
    },
    progress: {
      type: Number,
      default: 0,
    },
  },

  setup(props, ctx) {
    const progressValue = computed({
      get: () => props.progress,
      set: value => ctx.emit('update:progress', value),
    });

    return {
      progressValue,
    };
  },
});
